import Decimal from "decimal.js";
import { IShippingMethod } from "../types/types";

export default function getShippingRateDisplayPrice(
  rate: IShippingMethod,
  currencyCode: string,
  shippingConversionRate?: string,
) {
  const rateCurrencyCode = rate.currencyCode || currencyCode;
  if (rateCurrencyCode === currencyCode) {
    return {
      amount: new Decimal(rate.price).toFixed(2),
      currencyCode,
    };
  }

  if (rateCurrencyCode !== currencyCode && shippingConversionRate) {
    return {
      amount: new Decimal(rate.price).times(shippingConversionRate).toFixed(2),
      currencyCode,
    };
  }

  return {
    amount: new Decimal(rate.price).toFixed(2),
    currencyCode,
  };
}
